module.exports = __webpack_public_path__ + "static/media/megara-win.50fd4f7b.png";